export const FETCH_GATEWAYS_START = "FETCH_GATEWAYS_START";
export const FETCH_GATEWAYS_SUCCESS = "FETCH_GATEWAYS_SUCCESS";
export const FETCH_WITHDRAWALS_GATEWAYS_START = "FETCH_WITHDRAWALS_GATEWAYS_START";
export const FETCH_WITHDRAWALS_GATEWAYS_SUCCESS = "FETCH_WITHDRAWALS_GATEWAYS_SUCCESS";